<script setup lang="ts">
defineOptions({
    name: 'IdeoComboBoxOption'
});

const props = withDefaults(defineProps<{
    selected?: boolean;
    multiple?: boolean;
    disabled?: boolean;
    active?: boolean;
    empty?: boolean;
    display?: 'default' | 'status';
}>(), {
    selected: false,
    multiple: false,
    disabled: false,
    active: false,
    empty: false,
    display: 'default'
});

const emit = defineEmits<{
    (e: 'select'): void;
}>();
</script>

<template>
    <button
        type="button"
        role="option"
        :aria-selected="props.selected"
        :disabled="props.disabled"
        :class="[
            'group flex select-none min-h-[30px] w-full shrink-0 cursor-pointer items-center gap-[8px] rounded-[6px] border-0 bg-transparent px-[8px] py-[8px] text-start text-ui-body/[1.1] font-[400] text-fg outline-none [transition:background-color_0.08s_ease,color_0.08s_ease] motion-reduce:transition-none focus-visible:!bg-dropdown-hover disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:!bg-transparent disabled:hover:!text-fg dark:text-fg-dark dark:focus-visible:!bg-dropdown-hover-dark dark:disabled:hover:!bg-transparent dark:disabled:hover:!text-fg-dark',
            props.display === 'status' && props.selected && !props.empty ? '!bg-accent-soft !font-[500] dark:!bg-accent-soft-dark' : 'hover:!bg-dropdown-hover dark:hover:!bg-dropdown-hover-dark',
            props.display === 'status' ? '!min-h-[32px] !rounded-[8px] !px-[10px]' : '',
            props.active && !(props.display === 'status' && props.selected) ? '!bg-dropdown-hover dark:!bg-dropdown-hover-dark' : '',
            props.selected && !props.multiple && !props.empty ? '!text-accent-strong dark:!text-accent-strong-dark' : '',
            props.empty && !props.active ? '!text-fg-faint dark:!text-fg-faint-dark' : ''
        ]"
        @click="emit('select')"
    >
        <span
            v-if="props.multiple"
            :class="[
                'relative flex size-[15px] shrink-0 items-center justify-center rounded-[4px] border-[1.4px] outline-none [transition:background_.15s,border-color_.15s]',
                props.selected ? 'border-accent bg-accent' : 'border-border-strong bg-surface dark:border-border-strong-dark dark:bg-surface-dark'
            ]"
            aria-hidden="true"
        >
            <IdeoIcon v-if="props.selected" name="check" class="text-white dark:text-[oklch(0.2_0.01_260)]" :size="11" />
        </span>
        <span class="flex min-w-0 flex-1 items-center gap-[8px] whitespace-normal [overflow-wrap:anywhere]">
            <slot name="default" />
        </span>
        <IdeoIcon
            v-if="props.selected && !props.multiple && !props.empty"
            name="check"
            class="shrink-0 text-accent-strong dark:text-accent-strong-dark"
            :size="13"
            aria-hidden="true"
        />
    </button>
</template>
